import React from "react"
import { cn } from "lib/utils"
import { Titlebar } from "lib/components"
import { ElementButton } from "."
import type { ElementButtonProps } from "./ElementButton"


export default function ElementBox({
  title,
  item=null,
  editFn,
  buttons,
  comp,
  className="",
  children
}:{
  title:string;
  item?:any;
  editFn?:Function;
  buttons?:ElementButtonProps[];
  comp?:any
  className?:string;
  children?:React.ReactNode;
}){
  return (
    <div 
      className={cn(
        "w-full h-full border border-solid border-slate-700 p-[2px] *:text-neutral-200",
        className
      )}
    >
      <div className="w-full h-8 bg-slate-700 px-2 flex justify-between items-center">
        <Titlebar title={title} item={item} editFn={editFn} buttons={buttons} comp={comp} className="" />
      </div>
      <div className="w-full h-auto bg-slate-800 p-[2px] flex flex-col justify-start items-start *:text-xs">
        { children }
      </div>
    </div>
  )
}